import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dark-mode-toggle"
export default class extends Controller {
  connect() {
    // Find Root Node
    const rootNode = document.documentElement;

    // Use System Color Scheme
    if (rootNode.classList.contains('system')){
      const mediaQueryList = window.matchMedia('(prefers-color-scheme: dark)')

      // On Page Load
      if (mediaQueryList.matches){
        rootNode.classList.replace('system', 'dark')
      } else {
        rootNode.classList.replace('system', 'light')
      }

      // On Scheme Change
      mediaQueryList.onchange = (e) => {
        if (e.matches){
          rootNode.classList.replace('light', 'dark')
        } else {
          rootNode.classList.replace('dark', 'light')
        }
      }
    }

    // Special Key
    document.body.addEventListener('keydown', function(e) {
      if(!(e.code == 'KeyD' && e.ctrlKey)) return;
    
      e.preventDefault();

      if (rootNode.classList.contains('light')){
        rootNode.classList.replace('light', 'dark');
      } else {
        rootNode.classList.replace('dark', 'light');
      }
    });
  }
}
